import BreathingAnalytics from "../shared/BreathingAnalytics";

export default function PanicAnalytics() {
  return <BreathingAnalytics kind="panic" backTo="/app/panic" />;
}
